import type { GetServerSideProps } from "next";

import { loadPageWithGlobal } from "@shared/api";

import { getArticlePage } from "@/_pages/article/api";
import type { ArticleType } from "@/_pages/article/model";
import { ArticlePage } from "@/_pages/article/ui";

type Params = {
  slug: string;
};

type PageProps = {
  cms: ArticleType;
};

const Page = (props: PageProps) => {
  const { cms } = props;

  return <ArticlePage article={cms} />;
};

export const getServerSideProps: GetServerSideProps<{}, Params> = async (
  context,
) => {
  const { res } = context;
  const { slug } = context.params!;

  return await loadPageWithGlobal(
    async () => {
      const { article } = await getArticlePage(slug);

      return {
        ...article,
      };
    },
    { res },
  );
};

export default Page;
